import { getFirstWords } from "@/utils/helpers"
import { FaCrown, FaUserAlt } from "react-icons/fa"

export default function BoardLeaderItem({
  height,
  rank,
  name,
  score,
  image,
  isMe,
}: {
  height: string
  rank: number
  score: number
  name: string
  image?: string
  isMe?: boolean
}) {
  const crownColor =
    rank === 1
      ? "#FFD700"
      : rank === 2
        ? "#C0C0C0"
        : rank === 3
          ? "#CD7F32"
          : null

  return (
    <div
      className={`text-center d-flex flex-column align-items-center pt-3 ${isMe ? "me-highlight" : ""}`}
      style={
        isMe ? { filter: "drop-shadow(0 0 8px rgba(36, 59, 120, 0.3))" } : {}
      }
    >
      <div className="info mb-2 position-relative">
        {crownColor && (
          <div
            className="position-absolute"
            style={{
              top: "-18px",
              left: "50%",
              transform: "translateX(-50%) rotate(-10deg)",
              zIndex: 1,
            }}
          >
            <FaCrown size={20} color={crownColor} />
          </div>
        )}
        <div className="img-con mx-auto mb-2">
          {image ? (
            <img src={image} alt={name} />
          ) : (
            <div className="w-100 h-100 d-flex align-items-center justify-content-center bg-light text-muted">
              <FaUserAlt size={20} />
            </div>
          )}
        </div>
        <h2
          className="text-center m-0"
          title={name}
          style={{ fontSize: "13px", fontWeight: "600", color: "#444" }}
        >
          {getFirstWords(name)}
        </h2>
      </div>
      <div
        style={{
          height,
          background:
            rank === 1
              ? "linear-gradient(180deg, #FFD700 0%, #B8860B 100%)"
              : rank === 2
                ? "linear-gradient(180deg, #C0C0C0 0%, #808080 100%)"
                : rank === 3
                  ? "linear-gradient(180deg, #CD7F32 0%, #8B4513 100%)"
                  : undefined,
        }}
        className="bar"
      >
        <span className="num">{rank}</span>
        <span className="score">{score}%</span>
      </div>
    </div>
  )
}
